import axios from "../axios";

class CargoTypeService {
    getListIdNameAll() {
        return axios.get("cargo-type?perPage=1000&fields[cargo_type]=id,slug,name");
    }
}

export default new CargoTypeService();
